export default __webpack_public_path__ + "static/media/sv_7.8f5cc7b5.webp";